export const DEVSITE_PAGE_SCROLL_ID = 'devsite-page-scroll';

/** Set to 0 on the page scroller, which already starts below the navbar. Callers fall back to `navbarHeight`. */
export const DEVSITE_STICKY_TOP_VAR = '--devsite-sticky-top';

type PageScrollListener = (element: HTMLElement | null) => void;

/**
 * Module state, rather than React context, because route changes reset scroll from `AppRouter`,
 * which renders above the page tree and cannot read a provider that lives inside it.
 */
let pageScrollElement: HTMLElement | null = null;
const listeners = new Set<PageScrollListener>();

let documentScrollLockCount = 0;
let documentOverflowBeforeLock = '';

export const devsiteStickyTop = (fallback: string): string => `var(${DEVSITE_STICKY_TOP_VAR}, ${fallback})`;

/** Null while the window is the scrollport. */
export const getDevsitePageScrollElement = (): HTMLElement | null => pageScrollElement;

export const setDevsitePageScrollElement = (element: HTMLElement | null): void => {
  pageScrollElement = element;
  listeners.forEach((listener) => listener(element));
};

/** Fires immediately so a subscriber mounted after the chat opens still sees the current scroller. */
export const subscribeDevsitePageScrollElement = (listener: PageScrollListener): (() => void) => {
  listeners.add(listener);
  listener(pageScrollElement);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Stops the window from scrolling while the page scroller is active. Overlapping locks restore the
 * previous inline overflow only when the last one releases.
 *
 * No scrollbar gutter: with overflow hidden, a stable gutter paints an empty track on the chat's right edge.
 */
export const lockDocumentScroll = (): (() => void) => {
  if (documentScrollLockCount === 0) {
    documentOverflowBeforeLock = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
  }
  documentScrollLockCount += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    documentScrollLockCount -= 1;
    if (documentScrollLockCount > 0) return;

    document.documentElement.style.overflow = documentOverflowBeforeLock;
  };
};
